const DOMAIN_FIX = {
  "gmail.cz": "gmail.com", "gmail.con": "gmail.com", "gmial.com": "gmail.com", "gmail.comm": "gmail.com",
  "seznam.com": "seznam.cz", "senzam.cz": "seznam.cz", "seznma.cz": "seznam.cz", "sezman.cz": "seznam.cz",
  "centrum.com": "centrum.cz", "email.com": "email.cz", "volny.com": "volny.cz",
};
const DOMAINS = ["seznam.cz", "gmail.com", "email.cz", "centrum.cz", "volny.cz", "atlas.cz", "post.cz", "outlook.com", "outlook.cz", "hotmail.com", "icloud.com", "msmt.cz"];

function lev(a, b) {
  const dp = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 0; j <= b.length; j++) dp[0][j] = j;
  for (let i = 1; i <= a.length; i++)
    for (let j = 1; j <= b.length; j++)
      dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
  return dp[a.length][b.length];
}

export function emailSuggestion(email) {
  const m = /^([^@\s]+)@([^@\s]+\.[^@\s]{2,})$/.exec((email || "").trim().toLowerCase());
  if (!m) return null;
  const [, local, domain] = m;
  if (DOMAINS.includes(domain)) return null;
  if (DOMAIN_FIX[domain]) return `${local}@${DOMAIN_FIX[domain]}`;
  const tldFixed = domain.replace(/\.(zc|cs|czz|ccz)$/, ".cz").replace(/\.(con|comm|cmo|ocm|vom)$/, ".com");
  if (tldFixed !== domain) return `${local}@${tldFixed}`;
  for (const d of DOMAINS) if (lev(domain, d) === 1) return `${local}@${d}`;
  return null;
}

export function normalizePhoneCz(input) {
  let p = (input || "").replace(/[ \-().]/g, "");
  if (/^00420\d{9}$/.test(p)) p = "+420" + p.slice(5);
  else if (/^420\d{9}$/.test(p)) p = "+" + p;
  else if (/^\d{9}$/.test(p)) p = "+420" + p;
  if (!/^\+\d{10,15}$/.test(p)) return null;
  if (/^\+420\d{9}$/.test(p)) {
    const d = p.slice(4);
    return `+420 ${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6)}`;
  }
  return p;
}

export function checkSvpFile(file) {
  if (!file) return { ok: false, message: "Vyberte prosím soubor se svým ŠVP." };
  const name = file.name.toLowerCase();
  if (name.endsWith(".doc"))
    return { ok: false, message: "Soubor .doc je starší formát Wordu. Otevřete dokument ve Wordu, zvolte „Soubor → Uložit jako“ a vyberte formát .docx — ten pak nahrajte." };
  if (!name.endsWith(".pdf") && !name.endsWith(".docx"))
    return { ok: false, message: `Soubor „${file.name}“ bohužel neumíme přečíst. Nahrajte prosím své ŠVP jako PDF nebo dokument Wordu (.docx).` };
  if (file.size > 50 * 1024 * 1024)
    return { ok: false, message: "Soubor je větší než 50 MB. Zkuste PDF uložit znovu v menší velikosti (např. bez skenovaných obrázků) a nahrajte ho ještě jednou." };
  return { ok: true };
}
